import React from "react";
import { SURFACE, BORDER, TEXT, ACCENT } from "../constants/colors";
import { formatCurrency } from "../utils/formatCurrency";

const MetricStrip = ({ cards, metrics }) => {
  const totalValue = cards.reduce((s, c) => s + c.value, 0);
  const inTransitCards = cards.filter((c) => c.stage === "in_transit");
  const inTransitValue = inTransitCards.reduce((s, c) => s + c.value, 0);
  const inStockCards = cards.filter((c) => c.stage === "in_stock");
  const inStockValue = inStockCards.reduce((s, c) => s + c.value, 0);

  const items = [
    {
      label: "Total",
      value: formatCurrency(metrics?.pipeline_value?.value),
      sub: `${metrics?.pipeline_value?.count || 0} items`,
      color: ACCENT.indigo,
    },
    {
      label: "In Transit Supplier",
      value: formatCurrency(metrics?.in_transit_supplier?.value),
      sub: `${metrics?.in_transit_supplier?.count || 0} shipments`,
      color: ACCENT.blue,
    },
    {
      label: "In Transit Delivery",
      value: formatCurrency(metrics?.in_transit_delivery?.value),
      sub: `${metrics?.in_transit_delivery?.count || 0} items`,
      color: ACCENT.amber,
    },
    {
      label: "Warehouse Value",
      value: formatCurrency(metrics?.warehouse_value?.value),
      sub: `${metrics?.warehouse_value?.count || 0} SKUs`,
      color: ACCENT.green,
    },
  ];

  return (
    <div
      style={{
        background: SURFACE.metricStripBg,
        borderBottom: `1px solid ${BORDER.metricDivider}`,
        padding: "0 24px",
        display: "flex",
        gap: 0,
      }}
    >
      {items.map((m, i) => (
        <div
          key={i}
          style={{
            padding: "10px 20px",
            borderRight: `1px solid ${BORDER.metricDivider}`,
            flexShrink: 0,
          }}
        >
          <div
            style={{
              fontSize: 9,
              color: TEXT.dim,
              textTransform: "uppercase",
              letterSpacing: 1.5,
              marginBottom: 2,
              fontFamily: "Poppins",
            }}
          >
            {m.label}
          </div>
          <div
            style={{
              fontSize: 18,
              fontWeight: 700,
              color: m.color,
              fontFamily: "Poppins",
              letterSpacing: -0.5,
            }}
          >
            {m.value}
          </div>
          <div style={{ fontSize: 10, color: TEXT.dim }}>{m.sub}</div>
        </div>
      ))}
    </div>
  );
};

export default MetricStrip;
